import React from 'react'
import { Typography, Paper, Box } from '@material-ui/core'
import FolderOpenIcon from '@material-ui/icons/FolderOpen'

function EmptyState({
  isSearching,
  searchTerm,
  onClearSearch,
  title,
  description,
  searchDescription,
}) {
  const defaultTitle = isSearching ? 'No projects found' : 'No projects available'
  const defaultDescription = isSearching
    ? `No projects match "${searchTerm}". Try adjusting your search terms.`
    : 'There are no projects to configure prompts for at the moment.'

  return (
    <Paper
      elevation={0}
      style={{
        padding: '48px 24px',
        textAlign: 'center',
        backgroundColor: '#ffffff',
        marginTop: '24px',
      }}
    >
      <FolderOpenIcon style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
      <Typography variant="h6" color="textSecondary" gutterBottom>
        {title || defaultTitle}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {description ||
          (isSearching ? searchDescription || defaultDescription : defaultDescription)}
      </Typography>
      {isSearching && onClearSearch && (
        <Box mt={2}>
          <Typography
            variant="body2"
            color="primary"
            style={{ cursor: 'pointer' }}
            onClick={onClearSearch}
          >
            Clear search
          </Typography>
        </Box>
      )}
    </Paper>
  )
}

export default EmptyState
